module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.8984/img/business-types/retail.png"